<template>
  <div class="login-page">
    <div
      style="
        height: 80px;
        width: 600px;
        background-color: rgba(0, 0, 0, 0);
        position: absolute;
        top: 150px;
        left: 150px;
        font-size: 40px;
        line-height: 80px;
        text-align: center;
        color: #fff;
        font-weight: bold;
      "
    >
      综合管理平台<span style="font-size: 14px;margin-left: 5px;">({{ currentDomain }})</span>
    </div>
    <div class="login-container">
      <div
        style="
          height: 30px;
          width: 100%;
          text-align: center;
          line-height: 30px;
          margin-top: 0px;
          margin-bottom: 10px;
        "
      >
        <h2 style="color: #fff; line-height: 30px; margin-top: 0px">登录</h2>
      </div>

      <el-form :model="loginForm" :rules="rules" ref="loginFormRef">
        <el-form-item
          label=""
          prop="username"
          style="width: 80%; margin-left: 10%"
        >
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名"
            @keyup.enter="handleLogin"
          >
            <template #prefix>
              <el-icon><Avatar /></el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          label=""
          prop="password"
          style="width: 80%; margin-left: 10%"
        >
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            show-password
            @keyup.enter="handleLogin"
          >
            <template #prefix>
              <el-icon class="el-input__icon"><Hide /></el-icon>
            </template>
          </el-input>
        </el-form-item>
        <div style="width: 100%; display: flex; justify-content: center">
          <el-button
            type="primary"
            @click="handleLogin"
            style="width: 80%"
            :loading="loading"
            >登录</el-button
          >
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { Hide, Avatar } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import loginBg from "../assets/login-bg.jpg";
import { loginApi } from "../api/login";

export default {
  name: "LoginPage",
  components: {
    Hide,
    Avatar,
  },
  inject: ["setToken"],
  data() {
    return {
      loginBg,
      loginForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      loading: false,
      currentDomain: '',
    };
  },
  methods: {
    handleLogin() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          console.log("登录信息:", {
            username: this.loginForm.username,
            password: this.loginForm.password,
          });

          // 调用登录 API
          loginApi
            .login(this.loginForm.username, this.loginForm.password)
            .then((response) => {
              console.log("登录成功:", response);

              if (response.code === 200 && response.data.token) {
                const token = response.data.token;
                this.setToken(token);

                // 存储用户名到 Cookie
                const expires = new Date();
                expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000);
                document.cookie = `username=${
                  this.loginForm.username
                };expires=${expires.toUTCString()};path=/`;

                console.log("Token存储成功:", token);
                console.log("用户名存储成功:", this.loginForm.username);
                this.$router.push("/");
              } else {
                const errorMsg = response.msg || "未知错误";
                console.error("登录失败:", errorMsg);
                ElMessage.error(errorMsg);
              }
            })
            .catch((error) => {
              console.error("登录错误:", error);
              ElMessage.error("网络错误，请稍后重试");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
  mounted() {
    loginApi.getCurrentDomain().then((response) => {
      console.log(response,"fdsjifdjisfjisdjfisd");
      this.currentDomain = response.data.serverName || ''
    })
  },
};
</script>

<style scoped lang="less">
.login-page {
  width: 100vw;
  height: 100vh;
  background-image: url("../assets/bj.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;
}

.login-container {
  width: 300px;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: #ffffff52;
  position: absolute;
  top: 50%;
  right: 100px;
  transform: translateY(-50%);

  h2 {
    text-align: center;
    margin-bottom: 2rem;
    color: #333;
  }
}
</style>
